import Icon from '@/components/ui/AppIcon';

interface NewsPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const NewsPagination = ({ currentPage, totalPages, onPageChange }: NewsPaginationProps) => {
  const getVisiblePages = () => {
    const delta = 2;
    const range = [];
    
    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      range.unshift('...');
    }
    if (currentPage + delta < totalPages - 1) {
      range.push('...');
    }

    range.unshift(1);
    if (totalPages > 1) {
      range.push(totalPages);
    }

    return range;
  };

  const visiblePages = getVisiblePages();

  return (
    <div className="flex items-center justify-center space-x-2">
      {/* Previous Button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="flex items-center space-x-1 px-3 py-2 border border-border rounded-industrial bg-background text-foreground hover:bg-muted transition-industrial disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Icon name="ChevronLeftIcon" size={16} />
        <span className="hidden sm:inline font-heading font-bold uppercase tracking-wide text-xs">Previous</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center space-x-1">
        {visiblePages.map((page, index) => {
          if (page === '...') {
            return (
              <span key={`ellipsis-${index}`} className="px-3 py-2 text-text-secondary">
                ...
              </span>
            );
          }

          const pageNumber = page as number;
          const isActive = pageNumber === currentPage;

          return (
            <button
              key={pageNumber}
              onClick={() => onPageChange(pageNumber)}
              className={`px-3 py-2 rounded-industrial font-heading font-bold text-sm transition-industrial ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-background text-foreground border border-border hover:bg-muted'
              }`}
            >
              {pageNumber}
            </button>
          );
        })}
      </div>

      {/* Next Button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="flex items-center space-x-1 px-3 py-2 border border-border rounded-industrial bg-background text-foreground hover:bg-muted transition-industrial disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span className="hidden sm:inline font-heading font-bold uppercase tracking-wide text-xs">Next</span>
        <Icon name="ChevronRightIcon" size={16} />
      </button>
    </div>
  );
};

export default NewsPagination;